import { isEqual } from 'lodash';

import turfBuffer from '@turf/buffer';
import { Units, Feature } from '@turf/helpers';
import area from '@turf/area';

type GetBufferedPolygonParams = {
    coordinates: [number, number][];
    units?: Units;
    radius?: number;
    percentageOfArea?: number;
};

export const getBufferedPolygon = (params: GetBufferedPolygonParams) => {
    const { coordinates, units = 'kilometers', radius = 1, percentageOfArea } = params;

    const workingCoordinates = [...coordinates];
    const firstCoordinate = workingCoordinates[0];
    const lastCoordinate = workingCoordinates.at(-1);
    if (!isEqual(firstCoordinate, lastCoordinate)) {
        workingCoordinates.push(workingCoordinates[0]);
    }

    const polygonFeature = {
        type: 'Feature',
        properties: {},
        geometry: {
            type: 'Polygon',
            coordinates: [workingCoordinates], // Wrapping the coordinates array in another array as it's a polygon
        },
    } as Feature;

    // Calculate buffer radius based on polygon area if percentage is specified
    let bufferRadius = radius;
    if (percentageOfArea) {
        const polygonArea = area(polygonFeature); // Area in square meters
        const polygonRadius = Math.sqrt(polygonArea / Math.PI); // Radius of equivalent circle
        bufferRadius = polygonRadius * (percentageOfArea / 100); // 10% of the radius
    }

    // Create a buffer around the polygon using Turf.js
    const bufferedPolygon = turfBuffer(polygonFeature, bufferRadius, { units });

    return bufferedPolygon;
};
